<div class="dialog-prestations-info dialog">

    <div mat-dialog-title>
        <h2>Type de plate-forme</h2>
    </div>
    <mat-dialog-content class="body">

        <div>
            Vous trouverez ci dessous les différents types de plate-forme disponibles pour votre évènements ainsi que
            les options associées
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col" class="cell-icon">Start</th>
                    <th scope="col" class="cell-icon">Base</th>
                    <th scope="col" class="cell-icon">Full</th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-title">
                    <td colspan="4">Evènement</td>
                </tr>
                <tr>
                    <td class="cell-label">Coût par coureur (en sus)</td>
                    <td class="cell-icon">0€</td>
                    <td class="cell-icon">0€</td>
                    <td class="cell-icon">0,15€</td>
                </tr>
                <tr>
                    <td class="cell-label">Module speaker</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Ecran zone arrivée</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Catégories personalisées</td>
                    <td class="cell-icon">50€</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr class="row-title">
                    <td colspan="4">Coureurs</td>
                </tr>
                <tr>
                    <td class="cell-label">Drapeau du pays</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Ajout du surnom</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Photos de course (par photos)</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">0,20€</td>
                    <td class="cell-icon">0,20€</td>
                </tr>
                <tr class="row-title">
                    <td colspan="4">Chronométrage</td>
                </tr>
                <tr>
                    <td class="cell-label">Point départ/arrivée</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Classements scratch et catégories</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Points intermédiares</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Points intermédiare par smartphone</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Classements personalisés</td>
                    <td class="cell-icon">50€</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr class="row-title">
                    <td colspan="4">Live</td>
                </tr>
                <tr>
                    <td class="cell-label">Classement en direct</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Carte intéractive du parcours</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Profil interactif du parcours avec points</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Détail des points de passages</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <!-- <tr>
                    <td class="cell-label">Estimations passages</td>
                     <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                     <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">A venir</td>
                </tr> -->
                <tr class="row-title">
                    <td colspan="4">Communication</td>
                </tr>
                <tr>
                    <td class="cell-label">Bandeau partenaire</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Personalisation graphique</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">75€</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Diplome personalisé</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">100€</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Vidéo live</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Watermark vidéo live</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr class="row-title">
                    <td colspan="4">PC course</td>
                </tr>
                <tr>
                    <td class="cell-label">Import en live de coureurs</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Modifications live des coureurs</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Suivi des passages au point</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Gestion des passages détaillés</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr>
                    <td class="cell-label">Vidéo live</td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/red_cross.svg" alt="">
                    </td>
                    <td class="cell-icon">
                        <img class="icon-presta" src="/assets/icons/svg/check.svg" alt="">
                    </td>
                </tr>
                <tr class="row-title">
                    <td colspan="4">Total plate-forme</td>
                </tr>
                <tr>
                    <td>Coût plate-forme en suplément</td>
                    <td class="cell-icon">0€</td>
                    <td class="cell-icon">+150€</td>
                    <td class="cell-icon">+400€</td>
                </tr>
            </tbody>
        </table>

    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
        <button type="button" class="btn btn-light" mat-dialog-close>Fermer</button>
    </div>

</div>